const ITEMS = [
  "Psychologie du travail",
  "Neurosciences",
  "Leadership",
  "QVT — Qualité de vie au travail",
  "Haut potentiel",
  "Cohésion d'équipe",
  "Préparation mentale",
  "Performance humaine",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-[#D4AF37]/15 bg-[#0C1526] py-6 overflow-hidden"
    >
      <div className="marquee-track">
        {row.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-serif-display text-xl sm:text-2xl italic text-slate-400 px-8">
              {item}
            </span>
            <span className="text-[#D4AF37] text-xs">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
